import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e38a8c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-menu" }
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "flex align-items-center justify-content-center" }
const _hoisted_4 = { class: "flex align-items-center justify-content-center font-bold p-2" }
const _hoisted_5 = { class: "flex align-items-center justify-content-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "menu-separator"
}

export function render(_ctx, _cache) {
  const _component_p_avatar = _resolveComponent("p-avatar")
  const _component_app_side_item = _resolveComponent("app-side-item")

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_p_avatar, {
            image: _ctx.user.photo,
            icon: !_ctx.user.photo ?  'pi pi-user' : '',
            shape: "circle",
            style: {"background-color":"#2196f3","color":"#ffffff"},
            size: "xlarge"
          }, null, 8, ["image", "icon"])
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.user.name), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("i", null, _toDisplayString(_ctx.user.email), 1)
        ])
      ])
    ]),
    _hoisted_6,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item_side_menu, (item, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
        (!item.separator)
          ? (_openBlock(), _createBlock(_component_app_side_item, {
              key: 0,
              item: item,
              index: i
            }, null, 8, ["item", "index"]))
          : _createCommentVNode("", true),
        (item.separator)
          ? (_openBlock(), _createElementBlock("li", _hoisted_7))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}